module.exports = __webpack_public_path__ + "static/media/Special Needs.699a4bf2.jpg";